/**
 * React Query keys for workspace products (incl. BC URLs).
 * Single root spelling: `products`.
 */
export const productsQueryKeys = {
  /** Prefix: all product caches. */
  root: ['products'] as const,
  all: (workspaceId: string | null | undefined) =>
    ['products', workspaceId ?? null] as const,
  list: (
    workspaceId: string | null | undefined,
    search: string,
    page: number,
    pageSize: number,
    behaviorsKey: string,
    formsKey: string,
    materialsKey: string,
    colorsKey: string,
    sizesKey: string,
    languagesKey: string,
    locationId: string | null | undefined,
  ) =>
    [
      'products',
      workspaceId ?? null,
      search,
      page,
      pageSize,
      behaviorsKey,
      formsKey,
      materialsKey,
      colorsKey,
      sizesKey,
      languagesKey,
      locationId ?? null,
    ] as const,
  facets: (
    workspaceId: string | null | undefined,
    search: string,
    behaviorsKey: string,
    formsKey: string,
    materialsKey: string,
    colorsKey: string,
    sizesKey: string,
    languagesKey: string,
    locationId: string | null | undefined,
  ) =>
    [
      'product-facets',
      workspaceId ?? null,
      search,
      behaviorsKey,
      formsKey,
      materialsKey,
      colorsKey,
      sizesKey,
      languagesKey,
      locationId ?? null,
    ] as const,
  /** Prefix for facets invalidation. */
  facetsRoot: ['product-facets'] as const,
  detail: (
    workspaceId: string | null | undefined,
    productId: string | null | undefined,
  ) => ['products', workspaceId ?? null, 'detail', productId ?? null] as const,
  /** Product history pages (under the root, so product writes refresh it). */
  events: (
    workspaceId: string | null | undefined,
    productId: string | null | undefined,
  ) =>
    [
      'products',
      workspaceId ?? null,
      'detail',
      productId ?? null,
      'events',
    ] as const,
} as const;
